module.exports = __webpack_public_path__ + "img/ilioupoli-form-small.85a1b2ea.png";